import { render } from "./CarDashboard.vue?vue&type=template&id=5c5d9051"
import script from "./CarDashboard.vue?vue&type=script&lang=js"
export * from "./CarDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__